import { HttpClient } from '@angular/common/http';

import { CxsBasket, errorMessages } from '../model';
import { getBasket, getBasketWithHeaders } from '../services';
import { firstValueFrom } from 'rxjs';

/**
 * Requests a new basket or data from existing one
 * @param existingBasket stored basket data from previous session
 * @param httpClient
 * @param customerEmail
 */
export const loadBasket = async (
    existingBasket: CxsBasket | undefined,
    httpClient: HttpClient,
    customerEmail?: string
): Promise<CxsBasket> => {
    const http = await firstValueFrom(getBasketWithHeaders(httpClient, existingBasket?.basketId, customerEmail));
    const basket = http.body || existingBasket;
    if (http.status >= 400 || !basket) {
        throw Error(errorMessages.failedToLoadBasket);
    }
    if (http.status === 204 && basket.lastModifiedDate) {
        // If there is a local existing basket but not a remote one, the order must have been completed
        // However if that local existing basket is a new one (no modified date) no need to request another empty basket
        return await firstValueFrom(getBasket(httpClient));
    } else {
        return basket;
    }
};
